import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const items = [
  'Your account and profile information',
  'Personal data you submitted through our forms or services',
  'Communication history with our support team',
  'Any other data tied to your identity in our systems',
];

const WhatWeDelete = () => {
  return (
    <Container id="what-we-delete">
      <Box sx={{ my: 5 }}>
        <Typography
          variant="h4"
          sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
        >
          What Data Will Be Deleted
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 400,
            textAlign: 'left',
            my: 2,
            color: 'text.secondary',
          }}
        >
          Upon a verified deletion request, we will remove the following from
          our systems:
        </Typography>

        {items.map((item) => (
          <Box
            key={item}
            sx={{ display: 'flex', alignItems: 'flex-start', my: 1.5 }}
          >
            <Typography
              variant="h6"
              sx={{ mr: 1.5, color: 'primary.main', fontWeight: 700 }}
            >
              •
            </Typography>
            <Typography
              variant="h6"
              sx={{ fontWeight: 400, color: 'text.secondary' }}
            >
              {item}
            </Typography>
          </Box>
        ))}

        <Typography
          variant="h6"
          sx={{
            fontWeight: 400,
            textAlign: 'left',
            my: 3,
            color: 'text.secondary',
          }}
        >
          Please note that some data may be retained where required by law or
          for legitimate business purposes such as fraud prevention, in
          accordance with our{' '}
          <a href="/privacy-policy" style={{ color: 'inherit' }}>
            Privacy Policy
          </a>
          .
        </Typography>
      </Box>
    </Container>
  );
};

export default WhatWeDelete;
